export { getClinicalFields } from "./clinical"
export type { ClinicalInfo } from "./clinical"
export { contactIsNotEmpty, getContactFields, getInitialContactValue } from "./contact"
export { getPatientUserFields } from "./patientUser"
export { getTreatmentFields } from "./treatment"
export type { TreatmentInfo } from "./treatment"
